export const common = {
  contact: {
  	phone: '08 7082 4270',
    email: 'info@searchlighttechnology.com.au'
  },
  features: {
    STRATA_SEARCH: {
      states: [ 'WA', 'SA']
    },
    COUNCIL_SEARCH: {
      states: [ 'SA' ]
    },
    FORM1: {
      states: [ 'SA' ]
    },
    default_states: [ 'SA' ]
  }
};

export default common;
